import {formatToPersianAddComma, parseToEnRemoveComma} from "../../utils/CommaSeparator";

export const calculateSumOfEachRow = (tableArray = []) => {

  //debugger
  const tableData = [...tableArray];
  tableData.forEach((singleRow, index) => {

    let {price, discount, number} = singleRow;
    if (price === undefined) price = 0
    if (discount === undefined) discount = 0
    if (number === undefined) number = 0

    singleRow.total = (parseInt(parseToEnRemoveComma(price)) - parseInt(parseToEnRemoveComma(discount))) * parseFloat(parseToEnRemoveComma(number))
    singleRow.total = formatToPersianAddComma(singleRow.total)
  })
  return tableData
}

export const deleteRowHandler = (tableArray, productId, storeId) => {
  const table = [...tableArray];

  table.forEach((row, index) => {
    if (row.productId === productId && row.storeId === storeId) {
      table.splice(index, 1);
    }
  })
  return table
}


export const updateTableCellHandler = (tableArray, productId, storeId, field, newValue) => {

  const table = [...tableArray];

  table.forEach((row, index) => {

    if (row.productId === productId && row.storeId === storeId) {
      row[field] = newValue
      // table.splice(index, 1);
    }
  })
  return table

}
export const calculateSumOfTableData = (tableArray) => {


  if (tableArray) {

    const table = [...tableArray];
    return table.reduce((a, b) => a + +parseToEnRemoveComma(b.total), 0)
  }
  return 0
}

export const sumOfPaymentTable = (priceData) => {
  const table = [...priceData];
  return table.reduce((a, b) => a + +b.price, 0)
}

export const calculateTotalSum = (sendData) => {

  const data = {...sendData}
  let totalSum = 0;
  let taxPrice = 0
  if (Object.keys(data).length > 0) {
    if (data.servicePrice === undefined) data.servicePrice = 0;
    if (data.totalDiscount === undefined) data.totalDiscount = 0;
    if (data.tax === undefined) data.tax = 0;

    const sumBeforeDiscount = calculateSumOfTableData(data.tableData) + +data.servicePrice;
    const sumAfterDiscount = sumBeforeDiscount - data.totalDiscount;
    totalSum = sumAfterDiscount * (1 + (data.tax / 100))
    taxPrice = totalSum - sumAfterDiscount
  }


  return {sum: Math.floor(totalSum), taxPrice};
}

export const isPaymentAndFactorSumEqual = (sendData) => {
  const data = {...sendData}

  const totalSum = calculateTotalSum(data).sum
  const totalPayments = sumOfPaymentTable(data.priceData)

  // const priceData1 = sumOfPaymentTable(priceData)
  // const sumOfAllFactor1 = calculateSumOfTableData(sumOfAllFactor)
  return totalSum === totalPayments
}

export const isPaymentAndFactorSellSumEqual = (sendData) => {
  const data = {...sendData}
  let usedRemaining = 0
  if (sendData?.usedRemaining !== ""){
    usedRemaining = +sendData?.usedRemaining
  }
  const totalSum = calculateTotalSum(data).sum - usedRemaining
  const totalPayments = sumOfPaymentTable(data.priceData)

  // const priceData1 = sumOfPaymentTable(priceData)
  // const sumOfAllFactor1 = calculateSumOfTableData(sumOfAllFactor)
  return totalSum === totalPayments
}

export const myCustomCelEditFunction = (sendData, setSendData, cell, field, newValue) => {
  const productId = cell.getData().productId;
  const storeId = cell.getData().storeId;
  const tableData = updateTableCellHandler(sendData.tableData, productId, storeId, field, newValue);
  setSendData({tableData});

}
export const deleteExceptionKeysFromObject = (object) => {

  const myExceptionFields = object.exceptionFields;
  let newObject = {...object}
  for (const newObjectKey in newObject) {
    if (newObjectKey === 'exceptionFields') {
      delete newObject[newObjectKey]
    }

    if (myExceptionFields?.includes(newObjectKey)) {
      delete newObject[newObjectKey]
    }

  }


  return newObject
}
